import { Stack, Typography, StackProps, Checkbox, Box } from '@mui/material';
import { useAtom } from 'jotai';

import * as localState from '../state';
import { SavedBlockPoIsQuery, usePointOfInterestCuboidsLazyQuery } from '@/__generated__/graphql';
import { useSnackBarMessage } from '@/utils/useSnackBarMessage';
import { AnalysisCuboid } from '@/types';

type Props = {
  poi: SavedBlockPoIsQuery['pointOfInterests'][0];
  onRowClick?: () => void;
} & StackProps;

export const CustomSavedBlocksListItem = ({
  poi: { id, name, poiId },
  onRowClick,
  ...rest
}: Props) => {
  const { showSnackBar } = useSnackBarMessage({});
  const [customBlockCuboids, setCustomBlockCuboids] = useAtom(localState.customBlockCuboids);

  const [fetchCuboids, { loading: cuboidsLoading }] = usePointOfInterestCuboidsLazyQuery();

  const isSelected = customBlockCuboids.has(id ?? '');

  const handleCheckboxChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;

    if (!value) {
      setCustomBlockCuboids((current) => {
        const copy = current.asMutableStateMap();
        copy.delete(id);
        return copy.asStateMap();
      });
      return;
    }

    if (!id) {
      showSnackBar('Invalid data. Please contact support', 'error');
      return;
    }

    const response = await fetchCuboids({
      variables: {
        pointOfInterestId: id,
      },
      fetchPolicy: 'cache-first',
    });

    const poiData = response.data?.pointOfInterest;
    const cuboid = poiData?.cuboids?.[0];
    if (!cuboid) {
      showSnackBar('Invalid data. Please contact support', 'error');
      return;
    }

    setCustomBlockCuboids((current) => {
      const newCuboids = current.asMutableStateMap();
      newCuboids.set(id, {
        ...cuboid,
        id,
        name,
        status: poiData?.status,
      } as AnalysisCuboid);
      return newCuboids.asStateMap();
    });
  };
  return (
    <Stack
      direction="row"
      width="100%"
      sx={{ cursor: 'pointer', backgroundColor: 'white' }}
      height="100%"
      alignItems="center"
      onClick={onRowClick}
      {...rest}
    >
      {isSelected && <Box height={'100%'} width={'7px'} sx={{ backgroundColor: '#35c2a3' }} />}
      <Checkbox
        checked={isSelected}
        disabled={cuboidsLoading}
        onChange={handleCheckboxChange}
        onClick={(e) => e.stopPropagation()}
        sx={{ ml: 1, mr: 1 }}
      />
      <Typography fontSize="14px" color="primary.main">
        {name} - {poiId}
      </Typography>
    </Stack>
  );
};
